export default function PageHero({
    image,
    imagePosition = '72% center',
    variant = 'home',
    title,
    subtitle,
    children,
    compact = false,
}) {
    return (
        <section className={`redesign-hero redesign-hero-banner redesign-hero-banner--${variant}${compact ? ' redesign-hero-banner--compact' : ''}`}>
            <div className="redesign-hero-bg" aria-hidden="true">
                <img src={image} alt="" style={{ objectPosition: imagePosition }} />
            </div>
            <div className="redesign-hero-overlay" aria-hidden="true" />
            <div className="redesign-hero-content">
                {title && <h1 className="redesign-hero-title">{title}</h1>}
                {subtitle && <p className="redesign-hero-subtitle">{subtitle}</p>}
                {children}
            </div>
        </section>
    );
}
